<template>
<page
  :title='locationName'
  subTitle='Operating Hours'
  :crumbs="crumbs"
  :with-add='false'
  :with-refrehs='true'
  :back-path='basePath'
  :loading='request.loading'
  @refresh='get' >

  <template v-for='practitioner in practitioners' >
    <v-card outlined
      v-if='practitioner'
      :key='practitioner.id'
      class='ma-3 mt-4' >
      <v-card-title class='overline' >
        <practitioner-chip :item='practitioner' />
      </v-card-title>
        <!-- <pre v-text='practitioner' /> -->
        <hours-view
          :space-id='spaceId'
          :location="location"
          :practitioner="practitioner"
          @refresh='get' />
    </v-card>
  </template>
</page>
</template>

<script>
import Page from '@/components/layouts/Page'
import PractitionerChip from '@/components/listitems/PractitionerChip'
import HoursView from './operationhours/HoursView.vue'

import {mapGetters} from 'vuex'

export default {
  name: 'OperatingHoursPage',
  components: {Page, PractitionerChip, HoursView},
  props: {
    spaceId: { required: true },
    locationId: { required: true }
  },
  data () {
    return {
      dotw: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
      request: {
        resource: 'ag.spaces',
        result: {
          results: []
        }
      }
    }
  },
  computed: {
    ...mapGetters('identity', [
      'lookups',
      'getSpaceById',
      'practitionersList',
      'getPractitionersById',
      'getPractitionersInSpace',
      'getLocationBySpaceAndId'
    ]),
    basePath () {
      return `/settings/spaces/${this.spaceId}`
    },
    space () {
      if (this.spaceId) {
        return this.getSpaceById(this.spaceId)
      }
      return {}
    },
    spaceName () {
      return this.getObjectPath(this.space, 'title', '')
    },
    practitionerId () {
      if (this.selected && this.selected.id) { return this.selected.id }
      return null
    },
    practitioners () {
      if (this.space && this.space.members) {
        return this.getPractitionersById(this.space.members)
      } else {
        return this.practitionersList
      }
    },
    location () {
      if (this.spaceId && this.locationId) {
        return this.getLocationBySpaceAndId(this.spaceId, this.locationId)
      }
      return {}
    },
    locationName () {
      return this.getObjectPath(this.location, 'name', null)
    },
    crumbs () {
      let crumbs = [
        {text: 'Home', to: '/'},
        {text: 'Spaces', to: '/settings/spaces', 'exact': true }
      ]
      if (this.space && this.space.id) {
        crumbs.push({ text: this.spaceName, to: this.basePath, 'exact': true })
        crumbs.push({ text: 'Locations', to: this.basePath + '/locations', 'exact': true })
      }
      crumbs.push({text: this.locationName, disabled: true})
      return crumbs
    }
  },
  methods: {
    get () {
      this.lookup()
      // this.request.extra = 'operating-hours'
      // this.request.resourceId = this.spaceId
      // this.$request('get', this.request)
    },
    getHours (location, practitionerId) {
      return location.operation_hours.find((hrs) => {
        return String(hrs.practitioner) === String(practitionerId)
      })
    }
  }
}
</script>
